import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Goback from "./goBack.js"



export const CommonRoute = ({ component: Component, ...rest }) => {
  let userType
  if (rest.profileDetails) {
    if (rest.profileDetails.commonUser) {
      userType = rest.profileDetails.commonUser.userType;
      if(userType === "other"){
        userType = "patient"
      }
    }
  }
  return (<Route {...rest} render={props => rest.loginDetails === null ? (
    (
         
      <Redirect
        to={{
          pathname: "/login",
          state: { value : "sessionExpired"}
        }}
      />
    )
  ) :
    (rest.route === "common") ?
      <Component {...props} /> : (userType == rest.route) ? <Component {...props} /> : <Goback />

  }
  />
  );

}

const mapStateToProps = state => ({
  loginDetails: state.commonReducer.loginDetails,
  profileDetails: state.commonReducer.profileDetails,

})




export default connect(mapStateToProps)(CommonRoute);